module.exports = __webpack_public_path__ + "static/media/E603.8b06b62b.png";